import "./ChillWaterPumpsCoolingTowerService.module.css";
import Header from "@/reusable_sections/Header";
import ServiceHero from "./sections/ServiceHero";
import Services from "./sections/Services";
import Serviceareas from "./sections/Serviceareas";
import Quote from "./sections/Quote";
import Gallery from "./sections/Gallery";
import Footer from "@/reusable_sections/Footer";
export default function ChillWaterPumpsCoolingTowerServicePage() {
  return <div>
      <Header />
      <ServiceHero />
      <Services />
      <Serviceareas />
        <Gallery />
      <Quote />
    
      <Footer />
    </div>;
}